<span
  matBadgeOverlap="false"
  matBadgeColor="primary"
  [ngClass]="{ 'toggle-badge-padding': notificationBadgeCount$ | async }"
  [matBadge]="notificationBadgeCount$ | async"
  [matBadgeHidden]="hideBadge$ | async"
>
  <ng-content />
</span>
